export default __webpack_public_path__ + "7d8b6fa8bd016cacaca8573f0825b442.ttf";